import { Stack, Typography, useTheme } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { CampaignPricesDTO } from '@retail/my-assortment/types';
import { getLLDate } from '@retail/utils';

interface Props {
    campaignPrices: CampaignPricesDTO;
}

export function CampaignPrice({ campaignPrices }: Props) {
    const t = useMyAssortmentTFunction();
    const theme = useTheme();
    const palette = theme.vars.palette;
    const allCampaignPrices = [...campaignPrices.active, ...campaignPrices.future];

    return (<Stack my={1} p={2} gap={1} borderTop={`1px solid ${palette.divider}`} borderBottom={`1px solid ${palette.divider}`}>
        <Typography variant='body2'>{t('myAssortment.columns.campaignPrice.titlePlural')}</Typography>
        <Stack pl={2} display="grid" gridTemplateColumns="repeat(4, 1fr)" alignItems="center" rowGap={1} sx={{
            '& > *': { borderBottom: `1px solid ${palette.divider}` }, [`& > *:nth-last-of-type(-n+4)`]: {
                borderBottom: 'none'
            }
        }}>
            <Typography variant='body3' fontWeight={600}>{t('myAssortment.campaignSource.campaignName')}</Typography>
            <Typography variant='body3' fontWeight={600}>{t('myAssortment.columns.validFrom')}</Typography>
            <Typography variant='body3' fontWeight={600}>{t('myAssortment.columns.validTo')}</Typography>
            <Typography variant='body3' fontWeight={600}>{t('myAssortment.columns.campaignPrice.title')}</Typography>

            {allCampaignPrices.map((campaignPrice) => {
                return <>
                    <Typography variant='body3'>{campaignPrice.campaignName}</Typography>
                    <Typography variant='body3'>{getLLDate(campaignPrice.campaignValidFrom)}</Typography>
                    <Typography variant='body3'>{getLLDate(campaignPrice.campaignValidTo)}</Typography>
                    <Typography variant='body3'>{t('myAssortment.pricePerUnit', { price: campaignPrice.purchasePriceIncVat, unit: campaignPrice.unit })}</Typography>
                </>;
            })}
        </Stack>
    </Stack >);
}